export enum TrailerFilter {
    Trailer = 1,
    NonTrailer = 2
}
